import { setSelectedEpisodeId, selectEventId, registerSelectedEpisodeThunk, selectSelectedEpisodeId, clearSource, clearActiveMultipleSource, resetSubscribeChannelPresenceThunk, setSelectedAudioLanguage, setSelectedCCLanguage, resetLastPlayerLoggedId } from "@adm-media/adam-store-plugin";
import { batch, useDispatch, useSelector } from "react-redux";
/**
 * Hook to manage dis
 * @returns
 */
export var useSetCurrentEpisode = function () {
    var dispatch = useDispatch();
    var eventId = useSelector(selectEventId);
    var selectedEpisodeId = useSelector(selectSelectedEpisodeId);
    /**
     * Function that run registerSelectedEpisode => /${id}/select-episode/${episodeId}
     * and clean up if we have no episode id, or reset is launch
     */
    var setCurrentEpisode = function (_a) {
        var episodeId = _a.episodeId, doReset = _a.doReset;
        batch(function () {
            if (episodeId !== null)
                dispatch(registerSelectedEpisodeThunk({ eventId: eventId, episodeId: episodeId }));
            else if (episodeId === null) {
                dispatch(clearSource());
                dispatch(resetLastPlayerLoggedId());
                dispatch(clearActiveMultipleSource());
                dispatch(setSelectedAudioLanguage(null));
                dispatch(setSelectedCCLanguage(null));
            }
            dispatch(setSelectedEpisodeId(episodeId));
        });
        if (episodeId === null && selectedEpisodeId !== null && doReset) {
            dispatch(clearSource());
            dispatch(resetLastPlayerLoggedId());
            dispatch(clearActiveMultipleSource());
            dispatch(setSelectedAudioLanguage(null));
            dispatch(setSelectedCCLanguage(null));
            dispatch(resetSubscribeChannelPresenceThunk({}));
        }
    };
    return { setCurrentEpisode: setCurrentEpisode };
};
